module.exports = __webpack_public_path__ + "img/ds-16.1d2aac89.gif";